import { render } from "./AISalesContent.vue?vue&type=template&id=3272c782&scoped=true"
import script from "./AISalesContent.vue?vue&type=script&lang=js"
export * from "./AISalesContent.vue?vue&type=script&lang=js"

import "./AISalesContent.vue?vue&type=style&index=0&id=3272c782&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3272c782"]])

export default __exports__